// extracted by mini-css-extract-plugin
module.exports = {"courses":"Courses_courses_3M9zR","mobile":"Courses_mobile_xNYIL","heading":"Courses_heading_3ik27","list":"Courses_list_22k1u","item":"Courses_item_3psFV"};